import React from 'react'
import Modal from '@components/common/modal'

type Props = {
  isOpen: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  videoURL: string
}

const VideoModal = ({ isOpen, setIsOpen, videoURL }: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      isCrossIconShown={true}
      shouldCloseOnEsc
      width="mt-12 sm:mt-5"
      className="bg-black pl-0 pr-0"
    >
      <div>
        <iframe
          src={videoURL}
          frameBorder="0"
          className="-my-5 sm:-my-10 rounded-lg w-full h-80 sm:h-screen"
          allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
          allowFullScreen
        />
      </div>
    </Modal>
  )
}

export default VideoModal
